export class ValueDetail {
	public Code: string;
	public Value: string;
}
